export default {
  primaryColor: '#00F19F',
};
